import { render, staticRenderFns } from "./questionInputWidget.vue?vue&type=template&id=6e8e3af4&scoped=true"
import script from "./questionInputWidget.vue?vue&type=script&lang=js"
export * from "./questionInputWidget.vue?vue&type=script&lang=js"
import style0 from "./questionInputWidget.vue?vue&type=style&index=0&id=6e8e3af4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8e3af4",
  null
  
)

export default component.exports